import names from './actionNames';

export const loadingStarted = () => ({
  type: names.LOADING_STARTED
});

export const loadingFinished = () => ({
  type: names.LOADING_FINISHED
});
